import { FC } from 'react';

import InfoBlockWrapper, {
  InfoBlockDescription,
  InfoBlockPreview,
  InfoBlockTitle
} from './Wrapper';

export type InfoBlockProps = {
  title: string;
  description: string;
  preview?: string;
  className?: string;
};

const InfoBlock: FC<InfoBlockProps> = ({
  title,
  preview,
  className,
  description
}) => (
  <InfoBlockWrapper className={className}>
    <InfoBlockPreview src={preview} />
    <InfoBlockTitle>{title}</InfoBlockTitle>
    <InfoBlockDescription dangerouslySetInnerHTML={{ __html: description }} />
  </InfoBlockWrapper>
);

export default InfoBlock;
